import React from "react";
import { Filter } from "./styles";
import { StyledSelect } from "../../../../../../../components/StyledSelect";

const Component = ({ currentFilters, filter, initialFilters, addFilter, removeFilter, onChange, onClear, ...rest }) => {
  const getValue = () => {
    const filterValue = currentFilters[filter.id];
    if (rest.isMulti) {
      return filter.options.filter((item) => filterValue && filterValue.includes(item.value));
    }

    return filter.options.filter((item) => filterValue && filterValue === item.value);
  };

  return (
    <Filter className="form-group">
      <label htmlFor={filter.id} className="col-form-label pt-0 w-100">
        {filter.label}

        <StyledSelect
          id={filter.id}
          name={filter.id}
          options={filter.options}
          placeholder={filter.placeholder}
          defiaultValue={initialFilters[filter.id]}
          value={getValue()}
          onChange={(values, actions) => {
            if (actions.action === "clear" || (actions.action === "remove-value" && values.length <= 0)) {
              removeFilter(filter.id);
              if (onClear) {
                onClear();
              }
            } else {
              const fieldValue = rest.isMulti ? values.map((item) => item.value) : values.value;
              if (onChange) {
                onChange(fieldValue);
              }
              addFilter([{ key: filter.id, value: fieldValue }]);
            }
          }}
          isClearable
          isDisabled={filter.loading}
          isLoading={filter.loading}
          {...rest}
        />
      </label>
    </Filter>
  );
};

export default Component;
